import { z } from 'zod';

export const SubscriptionDataSchema = z.object({
  currency: z.string(),
  intro_offer_product_id: z.string(),
  payment_system: z.string(),
  price: z.string(),
  product_id: z.string(),
  subscription_id: z.string(),
  transaction_id: z.string(),
  cw_client_user_id: z.string().uuid(),
});

export type SubscriptionDataType = z.infer<typeof SubscriptionDataSchema>;
